import React from 'react';
import {Button, Callout, Card, Col, Dialog, DialogBody, DialogFooter, Icon, Row, ModalComponentProps, Yup, makeValidate} from '@mc/ui-v4';
import {Form, FormRenderProps} from 'react-final-form';
import {coordinatesSchema, createCoordsField} from './PointCoordsModal';
import {FieldArray} from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';
import {mcDelete, mcNew} from '@mc/react-ui-icons';

type CoordinatesList = {
    coordinates: {
        x: number | undefined;
        y: number | undefined;
    }[];
};
type Props = ModalComponentProps & {
    title: string;
    initialValues: CoordinatesList;
    onSubmit: (data: number[][]) => void;
};
const coordinatesListSchema = Yup.object().shape({
    coordinates: Yup.array().of(coordinatesSchema),
});

export const MultiCoordsModal: React.FC<Props> = ({title = 'Vytvoření linie zadáním souřadnic', initialValues, onClose, onSubmit}) => {
    const handleFormSubmit = (data: CoordinatesList) => {
        const transformedData = data.coordinates.map(coord => [coord.x!, coord.y!]);
        onSubmit(transformedData);
    };

    return (
        <Form<CoordinatesList>
            initialValues={initialValues}
            validate={async data => {
                const errors: {coords_empty?: string} = {};
                if (!data?.coordinates || data.coordinates.length < 2) {
                    errors.coords_empty = 'Zadejte alespoň dva páry souřadnic.';
                }
                const coordinatesListErrors = await makeValidate(coordinatesListSchema)(data);
                return {...errors, ...coordinatesListErrors};
            }}
            mutators={{...arrayMutators}}
            onSubmit={handleFormSubmit}
        >
            {({submitting, handleSubmit, errors}: FormRenderProps<CoordinatesList>) => (
                <Dialog onClose={onClose} title={title}>
                    <DialogBody className={'p-1'}>
                        <Card mode={'edit'} className="p-2">
                            {errors?.coords_empty && <Callout intent={'danger'}>{errors.coords_empty}</Callout>}
                            <FieldArray name={`coordinates`}>
                                {({fields}) => (
                                    <>
                                        {fields.map((name, index) => (
                                            <Row key={`${name}-${index}`}>
                                                <Col>{createCoordsField(submitting, `coordinates[${index}].x`, 'X')}</Col>
                                                <Col>{createCoordsField(submitting, `coordinates[${index}].y`, 'Y')}</Col>
                                                <Col className={'col-auto my-auto'}>
                                                    <Button
                                                        style={'default'}
                                                        className={'ml-1'}
                                                        icon={<Icon fixedWidth icon={mcDelete} />}
                                                        onClick={() => fields.remove(index)}
                                                        disabled={submitting}
                                                    />
                                                </Col>
                                            </Row>
                                        ))}
                                        <Row>
                                            <Col>
                                                <Button style="default" disabled={submitting} icon={<Icon icon={mcNew} />} onClick={() => fields.push({})}>
                                                    Přidat další souřadnice
                                                </Button>
                                            </Col>
                                        </Row>
                                    </>
                                )}
                            </FieldArray>
                        </Card>
                    </DialogBody>
                    <DialogFooter>
                        <Button danger disabled={submitting} onClick={onClose}>
                            Zrušit
                        </Button>
                        <Button style="primary" disabled={submitting} onClick={handleSubmit} type={'submit'}>
                            Vytvořit
                        </Button>
                    </DialogFooter>
                </Dialog>
            )}
        </Form>
    );
};
